import Decimal from 'decimal.js'
import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  setRequestSuccess,
  setRequestError,
} from '../../../../features/notifications'
import {
  AmountType,
  ClientPurse,
  ClientPurseResponse,
  DepositApproveRequest,
  DepositEdit,
  DepositStatus,
  UpdateAmount,
  Error,
  DividendBalance,
  dividendBalanceDefault,
  instalmentItemDefault,
  InstalmentItem,
  InstalmentItemResponse,
  AdjustmentDepositPayload,
} from './types'
import { $params } from '../../../../features/router'
import { transactionRequestStatus } from '../../const'

export const depositMounted = createEvent()
export const getInstalmentsEvent = createEvent()
export const setDeposit = createEvent<DepositEdit>()
export const submitEditDeposit = createEvent<DepositEdit>()
export const submitEditDepositAmount = createEvent<UpdateAmount>()
export const setAmount = createEvent<UpdateAmount>()
export const submitStatus = createEvent<DepositStatus>()
export const submitReject = createEvent<DepositStatus>()
export const submitRollback = createEvent<DepositStatus>()
export const submitCreateAdjustmentDeposit =
  createEvent<AdjustmentDepositPayload>()

export const $amount = restore(setAmount, {
  amount: {
    initialAmount: new Decimal(0),
    initialCurrency: '',
    initialCurrencyVisited: false,
    initialAmountVisited: false,
    clientAmount: new Decimal(0),
    clientCurrency: '',
    clientAmountVisited: false,
    clientCurrencyVisited: false,
    companyAmount: new Decimal(0),
    companyCurrency: '',
    companyAmountVisited: false,
    companyCurrencyVisited: false,
  },
  deposit: {
    transactionId: '',
    transactionType: '',
    clientId: '',
    gateway: {
      gatewayId: 0,
      internalName: '',
      paymentMethodType: '',
      processingProvider: '',
      exchanger: {
        id: '',
        frontName: '',
        balance: '',
      },
    },
    confirmedByManagerAt: '',
    confirmedByVendorAt: '',
    client: {
      clientId: '',
      email: '',
      fullName: '',
      partner: false,
      verified: false,
      wallets: [],
      accounts: [],
      exchanger: {
        id: '',
        frontName: '',
        balance: '',
      },
      isTest: false,
      isPremium: false,
      country: '',
    },
    clientPurse: {
      clientId: '',
      id: 0,
      expiry: '',
      isCard: false,
      verified: false,
      mask: '',
      type: '',
      bankName: '',
      clientName: '',
    },
    isAuto: false,
    isCard: false,
    needRecalculate: false,
    processingProvider: '',
    processingMethod: '',
    status: '',
    initialAmount: '',
    initialCurrency: '',
    initialAmountUsd: '',
    clientAmount: '',
    clientCurrency: '',
    companyAmount: '',
    companyCurrency: '',
    innerCommission: '',
    exchangeRate: '',
    clientCommission: '',
    companyCommission: '',
    commissionCurrency: '',
    createdAt: '',
    updatedAt: '',
    externalTransaction: {
      externalId: '',
    },
    externalPaymentTransaction: {
      externalId: '',
      externalStatus: '',
      initialAmount: '',
      initialCurrency: '',
      paidAmount: '',
      paidCurrency: '',
      vendorCommission: '',
      vendorCommissionCurrency: '',
      extraData: '',
    },
    providerId: '',
    psId: '',
    clientPurseId: 0,
    destinationType: '',
    rejectReason: '',
    psComment: '',
    managerComment: '',
    internalComment: '',
    destinationId: 0,
    changeHistory: {
      id: '',
      user: {
        email: '',
        fullName: '',
      },
    },
    changeHistoryAll: [],
    order: {
      orderId: 0,
      transactionRequestId: 0,
      gatewayId: 0,
      status: '',
      backendStatus: '',
      amount: 0,
      orderItems: [
        {
          PropertyID: 0,
          PropertyName: '',
          Amount: '',
          Price: '',
          TokenPrice: '',
        },
        {
          PropertyID: 0,
          PropertyName: '',
          Amount: '',
          Price: '',
          TokenPrice: '',
        },
      ],
    },
    hotBuyOrder: null,
    estimatedCommission: '',
  },
})
export const $deposit = restore(setDeposit, {
  transactionId: '',
  transactionType: '',
  clientId: '',
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
    verified: false,
    wallets: [],
    accounts: [],
    exchanger: {
      id: '',
      frontName: '',
      balance: '',
    },
    isTest: false,
    isPremium: false,
    country: '',
  },
  clientPurse: {
    clientId: '',
    id: 0,
    expiry: '',
    isCard: false,
    verified: false,
    mask: '',
    type: '',
    bankName: '',
    clientName: '',
  },
  gateway: {
    gatewayId: 0,
    internalName: '',
    paymentMethodType: '',
    processingProvider: '',
    exchanger: {
      id: '',
      frontName: '',
      balance: '',
    },
  },
  isAuto: false,
  isCard: false,
  needRecalculate: false,
  processingProvider: '',
  processingMethod: '',
  status: '',
  initialAmount: '',
  initialCurrency: '',
  initialAmountUsd: '',
  clientAmount: '',
  clientCurrency: '',
  companyAmount: '',
  companyCurrency: '',
  exchangeRate: '',
  clientCommission: '',
  companyCommission: '',
  commissionCurrency: '',
  innerCommission: '',
  createdAt: '',
  updatedAt: '',
  externalTransaction: {
    externalId: '',
  },
  externalPaymentTransaction: {
    externalId: '',
    externalStatus: '',
    initialAmount: '',
    initialCurrency: '',
    paidAmount: '',
    paidCurrency: '',
    vendorCommission: '',
    vendorCommissionCurrency: '',
    extraData: '',
  },
  providerId: '',
  psId: '',
  clientPurseId: 0,
  destinationType: '',
  rejectReason: '',
  psComment: '',
  managerComment: '',
  internalComment: '',
  destinationId: 0,
  changeHistory: {
    id: '',
    user: {
      email: '',
      fullName: '',
    },
  },
  changeHistoryAll: [],
  confirmedByVendorAt: '',
  confirmedByManagerAt: '',
  order: {
    orderId: 0,
    transactionRequestId: 0,
    gatewayId: 0,
    status: '',
    backendStatus: '',
    amount: 0,
    orderItems: [
      {
        PropertyID: 0,
        PropertyName: '',
        Amount: '',
        Price: '',
        TokenPrice: '',
      },
      {
        PropertyID: 0,
        PropertyName: '',
        Amount: '',
        Price: '',
        TokenPrice: '',
      },
    ],
  },
  hotBuyOrder: null,
  estimatedCommission: '',
})
export const setError = createEvent<Error>()
export const setSuccess = createEvent<Error>()

export const getClientPurses = fx<string, ClientPurseResponse>({
  method: 'GET',
  url: `/client_purse?where={"clientId":"1"}`,
})
export const submitDepositStatus = fx<DepositApproveRequest, DepositEdit>({
  method: 'PUT',
  url: `/transaction_request/`,
})
export const rejectDeposit = fx<DepositApproveRequest, DepositEdit>({
  method: 'PUT',
  url: `/transaction_request/`,
})
export const rollbackDeposit = fx<DepositApproveRequest, DepositEdit>({
  method: 'PUT',
  url: `/transaction_request/`,
})

export const getDeposit = fx<void, DepositEdit>({
  method: 'GET',
  url: '/transaction_request/',
})

export const updateDeposit = fx<DepositEdit, DepositEdit>({
  method: 'PUT',
  url: '/transaction_request/',
})

export const updateDepositAmount = fx<AmountType, DepositEdit>({
  method: 'PATCH',
  url: '/transaction_request/${id}',
})

export const getDividendBalance = fx<void, DividendBalance>({
  method: 'GET',
  url: '/nova/dividend_balance/',
})

export const getInstalments = fx<void, InstalmentItemResponse>({
  method: 'GET',
  url: '/nova/installment_payment/',
})

export const $clientPurses = restore<ClientPurse[]>(
  getClientPurses.doneData.map((a) => a.body.items),
  [],
)

export const createAdjustmentDepositFx = fx<
  AdjustmentDepositPayload,
  AdjustmentDepositPayload
>({
  method: 'POST',
  url: '/transaction_request/deposit/help-2-pay-adjustment',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const $success = restore(setSuccess, {
  message: '',
  code: 0,
})

export const $dividendBalance = restore<DividendBalance>(
  getDividendBalance.doneData.map((a) => a.body),
  dividendBalanceDefault,
)

export const $instalmentItem = restore<InstalmentItem>(
  getInstalments.doneData.map((a) => a.body.items[0]),
  instalmentItemDefault,
)

sample({
  clock: submitStatus,
  fn: ({ transactionId, status }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: status,
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: submitDepositStatus,
})

sample({
  clock: submitReject,
  fn: ({ transactionId }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: 'TRANSACTION_REQUEST_STATUS_REJECTED',
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: rejectDeposit,
})

sample({
  clock: submitRollback,
  fn: ({ transactionId }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: 'TRANSACTION_REQUEST_STATUS_ROLLBACK',
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: rollbackDeposit,
})

sample({
  clock: depositMounted,
  source: $params,
  fn: (params) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'Client.exchanger',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      url: `/transaction_request/${params?.depositID}`,
    }
  },
  target: getDeposit,
})

sample({
  clock: [
    getDeposit.doneData,
    submitDepositStatus.doneData,
    rejectDeposit.doneData,
    rollbackDeposit.doneData,
    updateDeposit.doneData,
  ],
  fn: (doneData) => doneData.body,
  target: [setDeposit],
})

sample({
  clock: getDeposit.doneData,
  fn: (doneData) => ({
    amount: {
      initialAmount: new Decimal(doneData.body.initialAmount),
      initialCurrency: doneData.body.initialCurrency,
      initialCurrencyVisited: false,
      initialAmountVisited: false,
      clientAmount: new Decimal(doneData.body.clientAmount),
      clientCurrency: doneData.body.clientCurrency,
      clientAmountVisited: false,
      clientCurrencyVisited: false,
      companyAmount: new Decimal(doneData.body.companyAmount),
      companyCurrency: doneData.body.companyCurrency,
      companyAmountVisited: false,
      companyCurrencyVisited: false,
    },
    deposit: doneData.body,
  }),
  target: [setAmount],
})

sample({
  clock: submitEditDeposit,
  source: $params,
  fn: (params, deposit) => {
    let id
    if (params) {
      id = params.depositID
    }
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      url: `/transaction_request/${id}`,
      body: { ...deposit },
    }
  },
  target: updateDeposit,
})

sample({
  clock: submitEditDepositAmount,
  source: $params,
  fn: (params, updateData) => {
    let id
    if (params) {
      id = params.depositID
    }
    return {
      url: `/transaction_request/${id}`,
      body: {
        initialAmount: new Decimal(updateData.deposit.initialAmount),
        initialCurrency: updateData.deposit.initialCurrency,
        initialAmountVisited: updateData.amount.initialAmountVisited,
        initialCurrencyVisited: updateData.amount.initialCurrencyVisited,
        clientAmount: new Decimal(updateData.deposit.clientAmount),
        clientCurrency: updateData.deposit.clientCurrency,
        clientAmountVisited: updateData.amount.clientAmountVisited,
        clientCurrencyVisited: updateData.amount.clientCurrencyVisited,
        companyAmount: new Decimal(updateData.deposit.companyAmount),
        companyCurrency: updateData.deposit.companyCurrency,
        companyAmountVisited: updateData.amount.companyAmountVisited,
        companyCurrencyVisited: updateData.amount.companyCurrencyVisited,
        needRecalculate:
          updateData.deposit.needRecalculate ||
          updateData.deposit.status == transactionRequestStatus.accepted(),
      },
    }
  },
  target: updateDepositAmount,
})

sample({
  clock: submitCreateAdjustmentDeposit,
  fn: (params: AdjustmentDepositPayload) => ({ body: params }),
  target: createAdjustmentDepositFx,
})

sample({
  clock: [getDeposit.doneData],
  fn: (item) => {
    return {
      url: `/client_purse?where={"clientId":"${item.body.client.clientId}"}`,
    }
  },
  target: getClientPurses,
})

sample({
  clock: updateDepositAmount.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: updateDepositAmount.failData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setSuccess],
})

sample({
  clock: updateDepositAmount.doneData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setError],
})

sample({
  clock: updateDepositAmount.doneData,
  fn: (doneData) => {
    return {
      message: 'Deposit amount successfully updated',
      code: doneData.status,
    }
  },
  target: [setSuccess],
})

sample({
  clock: [getDeposit.doneData],
  filter: (doneData) => doneData.body.product === 'nova',
  fn: (doneData) => ({
    url: `/nova/dividend_balance/${doneData.body.clientId}`,
  }),
  target: [getDividendBalance],
})

sample({
  clock: [getInstalmentsEvent],
  source: $params,
  fn: (params) => {
    let populate = JSON.stringify(['Installment.id'])
    return {
      url: `/nova/installment_payment?where={"transactionRequestId":"${params?.depositID}"}&populate=${populate}`,
    }
  },
  target: [getInstalments],
})

// Notifications for status change operations
sample({
  clock: [
    submitDepositStatus.done,
    rejectDeposit.done,
    rollbackDeposit.done,
    createAdjustmentDepositFx.done,
  ],
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: [
    submitDepositStatus.fail,
    rejectDeposit.fail,
    rollbackDeposit.fail,
    createAdjustmentDepositFx.fail,
  ],
  fn: ({ error }) => ({
    message:
      (error as any)?.body?.message ||
      (error as any)?.message ||
      'Unknown error',
    code: (error as any)?.status || 0,
  }),
  target: setRequestError,
})
